import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { IGetAbstractAsyncRequest, IGetAbstractAsyncResponse } from './models/abstract';
import { AxiosRequestConfig, Method } from 'axios';

export default class AbstractApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + 'services/Abstract/'
		};
	}

	public async getAbstractAsync(data: IGetAbstractAsyncRequest): Promise<IGetAbstractAsyncResponse> {
		const baseRequest = this.createBaseRequest();
		const request: AxiosRequestConfig = {
			...baseRequest,
			url: '/GetHitHighlightedAbstract',
			method: 'post' as Method,
			data: data
		};

		const response = await super.sendAsync<IGetAbstractAsyncResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while loading abstract.'));

		return response.data;
	}
}
